(function () {
  const html = document.documentElement;

  function isProductLink(a) {
    if (!a || !a.href) return false;

    // 只处理同域
    if (a.origin !== location.origin) return false;

    // 商品页
    if (!a.pathname.startsWith('/products/')) return false;

    // 排除锚点 / js
    if (a.getAttribute('href').startsWith('#')) return false;

    return true;
  }

  document.addEventListener(
    'click',
    function (e) {
      // ⚠️ 只在批发态下注入
      if (!html.classList.contains('ymq-wholesale-unlocked')) return;

      const a = e.target.closest('a');
      if (!isProductLink(a)) return;

      const url = new URL(a.href);

      // 已有就不动
      if (url.searchParams.has('wholesale')) return;

      url.searchParams.set('wholesale', '1');

      // 🔥 改写跳转目标（YMQ 来不及）
      a.href = url.toString();
    },
    true // ← 捕获阶段，关键
  );
})();

(function () {
  const params = new URLSearchParams(location.search);
  if (!params.has('wholesale')) return;

  const html = document.documentElement;

  function syncWholesale() {
    const radio = document.querySelector(
      'input[type="radio"][value="wholesale"]'
    );

    if (!radio) return false;

    // 已经同步过
    if (radio.checked) return true;

    radio.checked = true;
    radio.dispatchEvent(
      new Event('change', { bubbles: true })
    );

    html.classList.add('ymq-wholesale-unlocked');
    return true;
  }

  // 先试一次
  if (syncWholesale()) return;

  // 等 YMQ 渲染
  const mo = new MutationObserver(() => {
    if (syncWholesale()) mo.disconnect();
  });

  mo.observe(document.body, {
    childList: true,
    subtree: true
  });
})();




/* ======================================
   YMQ Upload Button – Custom Controller
   ====================================== */

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.ymq-option-upload-wrapper').forEach(wrapper => {
    if (wrapper.querySelector('.upload-modal')) return;

    const input = wrapper.querySelector('.ymq-option-upload-input');
    if (!input) return;

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'upload-modal jb-btn btn-secondary';
    btn.innerHTML = `
      <div class="btn-inner-wrapper">
        <div class="text-content">
          <span class="main">Upload Your Design</span>
          <span class="description">
Or Add to Cart and upload files later to Info@feystar.com.
          </span>
        </div>
        <div class="svg with-icon">
  <svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 20 20"
  width="16"
  height="16"
  fill="none"
  stroke="currentColor"
  stroke-width="1"
  stroke-linecap="round"
  stroke-linejoin="round"
>
  <!-- 向上箭头 -->
  <path d="M10 12V4"></path>
  <path d="M7 7l3-3 3 3"></path>

  <!-- 底座 -->
  <path d="M4 13.5v2h12v-2"></path>
</svg>



        </div>
      </div>
    `;

    btn.addEventListener('click', () => input.click());

    input.addEventListener('change', () => {
      btn.classList.remove('is-error');
      if (input.files && input.files.length > 0) {
        btn.classList.add('is-filled');
        btn.querySelector('.description').textContent =
          `${input.files.length} file(s) selected`;
      } else {
        btn.classList.remove('is-filled');
        btn.querySelector('.description').textContent =
          `Upload your finished design here. We’ll handle the rest!`;
      }
    });

    wrapper.prepend(btn);

    const errorBox = wrapper.parentElement.querySelector('.ymq-option-error');
    if (errorBox) {
      new MutationObserver(() => {
        if (errorBox.textContent.trim() !== '') {
          btn.classList.add('is-error');
        }
      }).observe(errorBox, { childList: true, subtree: true });
    }
  });
});

/* ======================================
   YMQ discount – Result-driven Controller
   ====================================== */

(function () {

  const $  = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  /* ========= 新增：slider 写入锁（唯一新增全局变量） ========= */
  let __ymqSliderWriting = false;
    /* =========监听点击选项 ========= */
function watchYmqOptions(optionRoot, onChange) {
  const radios = optionRoot.querySelectorAll('.ymq-option-rc-input');
  radios.forEach(radio => {
    if (radio.dataset.watched) return; // 只绑定一次
    radio.dataset.watched = '1';

    radio.addEventListener('change', () => {
      onChange();
    });
  });

  // 如果选项是动态渲染的，可以用 MutationObserver 自动绑定新节点
  new MutationObserver(muts => {
    muts.forEach(m => {
      m.addedNodes.forEach(node => {
        if (!(node instanceof HTMLElement)) return;
        const newRadios = node.querySelectorAll?.('.ymq-option-rc-input') || [];
        newRadios.forEach(r => {
          if (r.dataset.watched) return;
          r.dataset.watched = '1';
          r.addEventListener('change', () => onChange());
        });
      });
    });
  }).observe(optionRoot, { childList: true, subtree: true });
}


  /* ================= 工具：送达日期 ================= */

  function formatDeliveryDate(days = 7) {
    const d = new Date();
    d.setDate(d.getDate() + days);
    return d.toLocaleDateString('en-US', {
      weekday: 'long',
      month: 'short',
      day: 'numeric'
    });
  }

  /* ================= 读取阶梯 ================= */
function readTiers(optionRoot) {
  const tiers = [];

  // 找到当前可见的 box
  const activeBox = optionRoot.querySelector('.discountclass:not(.ymq-option-condition-hide)');
  console.log('🔹 activeBox:', activeBox);
  if (!activeBox) {
    console.warn('⚠️ 没有找到可见的阶梯 box');
    return tiers;
  }

  // 遍历当前 box 下的所有选项
  $$('.ymq-option-qb-item', activeBox).forEach((item, index) => {
    if (item.classList.contains('ymq-option-qb-item-result')) {
      console.log(`跳过结果行 index=${index}`);
      return;
    }

    const qtyEl   = $('.ymq-option-qb-quantity', item);
    const priceEl = $('.ymq-price-span[data-ymq-money]', item);
    const saveEl  = $('.ymq-option-qb-discount', item);

    console.log(`item index=${index}`, { qtyEl, priceEl, saveEl });

    if (!qtyEl || !priceEl) {
      console.warn(`⚠️ 找不到 qty 或 price 元素 index=${index}`);
      return;
    }

    const qty   = parseInt(qtyEl.textContent.replace(/\D/g, ''), 10);
    const price = parseFloat(priceEl.dataset.ymqMoney);
    const save  = saveEl
      ? parseInt(saveEl.textContent.replace(/\D/g, ''), 10)
      : 0;

    if (!Number.isFinite(qty) || !Number.isFinite(price)) {
      console.warn(`⚠️ qty 或 price 不是有效数字 index=${index}`, { qty, price });
      return;
    }

    console.log(`✅ 解析成功 index=${index}`, { qty, price, save });
    tiers.push({ qty, price, save });
  });

  tiers.sort((a, b) => a.qty - b.qty);
  console.log('最终 tiers:', tiers);
  return tiers;
}
// ✅ 新增：从 YMQ 正确读取 base 原价
function readBasePrice(optionRoot) {
  const el = optionRoot.querySelector(
    '.ymq-option-qb-compared-price .ymq-price-span[data-ymq-money]'
  );
  if (!el) return null;
  return parseFloat(el.dataset.ymqMoney);
}
/* ================= 统一单价计算核心 ================= */
function calculateUnitPrice(optionRoot, qty) {

  const priceEl = optionRoot.querySelector(
    '.discountclass:not(.ymq-option-condition-hide) .ymq-option-qb-item-result .ymq-price-span[data-ymq-money]'
  );

  if (!priceEl) return null;

  const unit = parseFloat(priceEl.getAttribute('data-ymq-money'));

  if (!Number.isFinite(unit)) return null;

  // 折扣只是展示用途
  const discountEl = optionRoot.querySelector(
    '.discountclass:not(.ymq-option-condition-hide) .ymq-option-qb-item-result .ymq-option-qb-discount'
  );

  let discount = 0;
  if (discountEl) {
    const text = discountEl.textContent.replace(/[^\d.]/g, '');
    discount = parseFloat(text) || 0;
  }

  return {
    unit: unit,     // ⭐ 直接使用插件真实成交单价
    save: discount
  };
}
  function tierByQty(qty, tiers) {
    for (let i = tiers.length - 1; i >= 0; i--) {
      if (qty >= tiers[i].qty) return tiers[i];
    }
    return tiers[0];
  }
  /*
  function getBasePriceFromFirstTier(tiers) {
    const first = tiers[0];
    if (!first.save || first.save <= 0) return first.price;
    return first.price / (1 - first.save / 100);
  }
 */
  /* ================= 监听 result 价格变化 ================= */

  function watchResultPrice(optionRoot, onChange) {
    const priceEl = optionRoot.querySelector(
      '.ymq-option-qb-item-result .ymq-price-span[data-ymq-money]'
    );
    if (!priceEl) return;

    let last = priceEl.dataset.ymqMoney;

    new MutationObserver(() => {
      const cur = priceEl.dataset.ymqMoney;
      if (!cur || cur === last) return;
      last = cur;
      onChange();
    }).observe(priceEl, {
      attributes: true,
      attributeFilter: ['data-ymq-money']
    });
  }
/* ================= Unlock 行（插入到计算区前） ================= */

function initWholesaleUnlockRow(optionRoot) {
  const qtyCard = optionRoot.querySelector('.ymq-qty-card');
  if (!qtyCard) return;

  if (optionRoot.querySelector('.ymq-unlock-wholesale')) return;

  const tiers = $$('.ymq-option-qb-item', optionRoot)
    .filter(i => !i.classList.contains('ymq-option-qb-item-result'));
  if (tiers.length < 4) return;

  const qtyEl = $('.ymq-option-qb-quantity', tiers[3]);
  const qtyText = qtyEl ? qtyEl.textContent.trim() : '';

  const row = document.createElement('div');
  row.className = 'ymq-unlock-row ymq-unlock-wholesale';
  row.innerHTML = `
    <div class="ymq-option-label">
      <div class="col-radio-placeholder"></div>
      <div class="ymq-option-qb-content">
        <span class="ymq-unlock-text">
          ${qtyText ? `(Buy ${qtyText}) ` : ''}Unlock Your Wholesale Price
        </span>
      </div>
    </div>
  `;

  row.addEventListener('click', e => {
    e.preventDefault();
    e.stopPropagation();

    const html = document.documentElement;

    /* 🔥 核心：明确切状态，不用 toggle */
    html.classList.remove('ymq-regular-unlocked');
    html.classList.add('ymq-wholesale-unlocked');

    /* 可选：滚到 product-form 顶部 */
    const form = document.querySelector('.product-form');
    if (form) {
      form.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });

  qtyCard.parentNode.insertBefore(row, qtyCard);
}

function syncWholesaleRadioUnlock() {
  let wholesaleRadio = document.querySelector('input[type="radio"][value="wholesale"]');

  // 核心同步函数
  const updateUnlockClass = () => {
    if (wholesaleRadio?.checked) {
      document.documentElement.classList.add('ymq-wholesale-unlocked');
    } else {
      document.documentElement.classList.remove('ymq-wholesale-unlocked');
    }
  };

  // 初次同步状态
  updateUnlockClass();

  // 监听 radio 变化
  wholesaleRadio?.addEventListener('change', updateUnlockClass);

  // 监听 DOM 更新，防止 radio 被替换
  const observer = new MutationObserver(() => {
    const newRadio = document.querySelector('input[type="radio"][value="wholesale"]');
    if (newRadio !== wholesaleRadio) {
      wholesaleRadio?.removeEventListener('change', updateUnlockClass);
      wholesaleRadio = newRadio;
      wholesaleRadio?.addEventListener('change', updateUnlockClass);
      updateUnlockClass();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // 页面刷新后保持状态
  window.addEventListener('load', updateUnlockClass);
}

// 调用函数
syncWholesaleRadioUnlock();
  /* =====
function reorderYmqQuestions() {
  const ymq = document.querySelector('ymq-option');
  if (!ymq) return;

  let wrapper = ymq.querySelector('.my-ymq-wrapper');
  if (!wrapper) {
    wrapper = document.createElement('div');
    wrapper.className = 'my-ymq-wrapper';
    ymq.prepend(wrapper);
  }

  const boxes = [...ymq.querySelectorAll('.ymq-options-box')];
  boxes.forEach(box => wrapper.appendChild(box));

  const order = [
    'productclass',
    'materialclass',
    'sizeclass',
    'discountclass',
    'shapeclass',
    'finishclass',
    'laterclass',
    'uploadclass'
  ];

  order.forEach(cls => {
    const el = wrapper.querySelector(`.${cls}`);
    if (el) wrapper.appendChild(el);
  });
}
============== */


function initCustomQtyRow(optionRoot) {
  const qtyCard = optionRoot.querySelector('.ymq-qty-card');
  if (!qtyCard) return;

  if (optionRoot.querySelector('.ymq-unlock-custom')) return;

  const row = document.createElement('div');
  row.className = 'ymq-unlock-row ymq-unlock-custom';
  row.innerHTML = `
    <div class="ymq-option-label">
      <div class="col-radio-placeholder"></div>
   
      <div class="ymq-custom-qty-body">
      </div>
    </div>
  `;

 

  qtyCard.parentNode.insertBefore(row, qtyCard);
}


  /* ================= 数量 + 价格卡 ================= */

  function initQtyCard(container, optionRoot) {


 



    if (container.dataset.qtyCardInit) return;
    container.dataset.qtyCardInit = '1';

    const input = $('.ymq-option-quantity-input', container);
    // ✅ 防止重复绑定
  if (!input.__selectBinded) {
    input.__selectBinded = true;

    input.addEventListener('focus', function () {
      try {
        input.select();
      } catch (e) {}
    });
  }
    const uploadAnchor = $('.ymq-option-upload-wrapper', optionRoot);
    if (!input || !uploadAnchor) return;

    const radioPlaceholder = document.createElement('div');
    radioPlaceholder.className = 'ymq-radio-placeholder';

    const card = document.createElement('div');
    card.className = 'ymq-price-card ymq-qty-card';

    const row = document.createElement('div');
    row.className = 'ymq-qty-card-row';

// ❗ 只取消 UI 显示，不动 YMQ 内部状态
    function updateTierUIByQty(optionRoot, qty) {
  const tiers = readTiers(optionRoot);
  if (!tiers.length) return;

  const isExactTier = tiers.some(t => t.qty === qty);

  optionRoot
    .querySelectorAll('.ymq-option-qb-item')
    .forEach(item => {
      if (!isExactTier) {
        // ❗ 只取消 UI 显示，不动 YMQ 内部状态
        item.classList.remove('ymq-option-qb-item-active');
                // ② ⭐ 加一个 UI-only 抑制 class
        item.classList.add('ymq-tier-ui-muted');
      } else {
        item.classList.remove('ymq-tier-ui-muted');

      }
    });
}

 /* =========================
     qty input → 激活计算条
     （只加 class，不改样式）
     ========================= */
 function syncActiveState() {
  const qty = parseInt(input.value, 10);

  // 非法 / 空值
  if (!Number.isFinite(qty) || qty <= 0) {
    row.classList.remove('is-active');
    return;
  }

  // 读取阶梯
  const tiers = readTiers(optionRoot);
  const isTierQty = tiers.some(t => t.qty === qty);

  // ⭐ 核心规则
  if (isTierQty) {
    // qty = 阶梯值 → 计算条不 active
    //row.classList.remove('is-active');
  } else {
    // qty ≠ 阶梯值 → 自定义数量 → 计算条 active
    row.classList.add('is-active');
  }
}





    const bar = document.createElement('div');
    bar.className = 'ymq-price-bar';
    bar.innerHTML = `
         <span class="ymq-price-unit">—</span>
         <span class="ymq-price-total">—</span>
         <span class="ymq-price-savings">—</span>
    `;

  const customBody = optionRoot.querySelector('.ymq-custom-qty-body');

if (customBody) {
  customBody.appendChild(card);
} else {
  uploadAnchor.before(card); // 兜底，防炸
}
    card.appendChild(row);
    row.appendChild(radioPlaceholder);
    row.appendChild(container);
    row.appendChild(bar);
  const unitEl  = $('.ymq-price-unit', bar);
    const totalEl = $('.ymq-price-total', bar);
  
    const saveEl  = $('.ymq-price-savings', bar);

function sync() {
  /* ===== slider 写入保护 ===== */
 // if (__ymqSliderWriting) return;
// ⭐ 只在「slider 正在 commit」时跳过
  if (__ymqSliderWriting && document.activeElement !== input) return;

  const qty = parseInt(input.value, 10);
  if (!Number.isFinite(qty) || qty <= 0) return;
// ⭐ UI 规则：qty 非阶梯整数 → 不显示任何阶梯选中
  updateTierUIByQty(optionRoot, qty);


  /* ===== 读取阶梯（只读） ===== */
  const tiers = readTiers(optionRoot);
  if (!tiers.length) return;
const result = calculateUnitPrice(optionRoot, qty);
if (!result) return;

const unitPrice = result.unit;
const savePct   = result.save;

  /* ===== 货币符号（安全、只读） ===== */
  let symbol = '$';
  const anyPriceSpan = optionRoot.querySelector(
    '.ymq-price-span[data-ymq-money]'
  );
  if (anyPriceSpan && anyPriceSpan.textContent) {
    const m = anyPriceSpan.textContent.match(/^[^\d]+/);
    if (m) symbol = m[0].trim();
  }

  /* ===== 输出 ===== */
  unitEl.textContent  = symbol + unitPrice.toFixed(3) + ' / each';
  totalEl.textContent = ' ' + symbol + (unitPrice * qty).toFixed(2);
  saveEl.textContent  = savePct ? `Save ${savePct}%` : '';
}



    input.addEventListener('input', sync);
    input.addEventListener('change', sync);

    input.addEventListener('input', syncActiveState);
input.addEventListener('change', syncActiveState);

    watchResultPrice(optionRoot, sync);
watchYmqOptions(optionRoot, sync);

    let lastQty = input.value;

    new MutationObserver(() => {
      if (input.value !== lastQty) {
        lastQty = input.value;
        sync();
      }
    }).observe(input, {
      attributes: true,
      attributeFilter: ['value']
    });

    setInterval(() => {
      if (input.value !== lastQty) {
        lastQty = input.value;
        sync();
      }
    }, 200);

    sync();
    syncActiveState();

  }

/* ================= Slider + Delivery Bar ================= */

function watchTotalPrice(optionRoot, onChange) {
  const totalEl = optionRoot.querySelector('.ymq-price-total');
  if (!totalEl) return;

  let last = totalEl.textContent;

  new MutationObserver(() => {
    const cur = totalEl.textContent;
    if (!cur || cur === last) return;
    last = cur;
    onChange();
  }).observe(totalEl, {
    childList: true,
    subtree: true,
    characterData: true
  });
}


function initSlider(optionRoot) {
  if (optionRoot.dataset.sliderInit) return;
  optionRoot.dataset.sliderInit = '1';

  const uploadAnchor = $('.ymq-option-upload-wrapper', optionRoot);
  const input = $('.ymq-option-quantity-input', optionRoot);
  if (!uploadAnchor || !input) return;

  const slider = document.createElement('div');
  slider.className = 'ymq-qty-slider';
  slider.innerHTML = `
    <div class="ymq-qty-track"><div class="ymq-qty-progress"></div></div>
    <div class="ymq-qty-thumb">
      <div class="ymq-qty-bubble ymq-qty-bubble-top"></div>
      <div class="ymq-qty-bubble ymq-qty-bubble-bottom"></div>
    </div>
  `;
  uploadAnchor.before(slider);

  const deliveryBar = document.createElement('div');
  deliveryBar.className = 'ymq-delivery-bar';
  deliveryBar.innerHTML = `
    <span class="ymq-delivery-text">
      Get it delivered as soon as
      <strong class="ymq-delivery-date">—</strong>
    </span>
    <div class="ymq-delivery-price-wrap">
     <span class="ymq-delivery-badge" hidden>—</span>
      <span class="ymq-delivery-total">—</span>
    </div>
  `;
  slider.after(deliveryBar);

  function syncDeliveryBar() {
    const totalEl = $('.ymq-price-total', optionRoot);
    const unitEl  = $('.ymq-price-unit', optionRoot);
    const badgeEl = deliveryBar.querySelector('.ymq-delivery-badge');

    if (!totalEl || !unitEl || !badgeEl) return;

    const qty = parseInt(input.value, 10);
    if (!Number.isFinite(qty) || qty <= 0) {
      badgeEl.hidden = true;
      return;
    }

    deliveryBar.querySelector('.ymq-delivery-date').textContent =
      formatDeliveryDate(7);

    deliveryBar.querySelector('.ymq-delivery-total').textContent =
      totalEl.textContent;

    const unitPrice = unitEl.textContent.split('/')[0].trim();
    badgeEl.textContent = `   ${unitEl.textContent}`;
    badgeEl.hidden = false;
  }

  input.addEventListener('input', syncDeliveryBar);
  input.addEventListener('change', syncDeliveryBar);
  watchTotalPrice(optionRoot, syncDeliveryBar);

  const track = $('.ymq-qty-track', slider);
  const prog  = $('.ymq-qty-progress', slider);
  const thumb = $('.ymq-qty-thumb', slider);
  const bt = $('.ymq-qty-bubble-top', slider);
  const bb = $('.ymq-qty-bubble-bottom', slider);

  let dragging = false;

  function stopDrag() {
    if (!dragging) return;

    dragging = false;

    document.removeEventListener('mousemove', onMove);
    document.removeEventListener('mouseup', stopDrag);
    document.removeEventListener('touchmove', onMove);
    document.removeEventListener('touchend', stopDrag);

    // ⭐ 关键修复：只有真正拖动了才提交，且只更新 slider 显示，不强制改 input
    if (slider._previewQty && slider._previewQty !== parseInt(input.value)) {
      // 用户通过 slider 选择了新值，此时才更新 input
      __ymqSliderWriting = true;
      input.value = slider._previewQty;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));

      setTimeout(() => {
        __ymqSliderWriting = false;
      }, 0);
    }
  }

  /*- ⭐ 关键修复：根据数量计算单价，不依赖激活状态
  function getUnitPriceByQty(qty) {
    const tiers = readTiers(optionRoot);
    if (!tiers.length) return null;

    // qty < 最低阶梯 → 使用 base 价格
    if (qty < tiers[0].qty) {
      return readBasePrice(optionRoot);
    }

    // ⭐ 找到 qty 所在的阶梯（最后一个满足 qty >= tier.qty 的阶梯）
    let matchedTier = null;
    for (let i = tiers.length - 1; i >= 0; i--) {
      if (qty >= tiers[i].qty) {
        matchedTier = tiers[i];
        break;
      }
    }

    // 如果找到匹配的阶梯，使用该阶梯价格
    if (matchedTier) {
      return matchedTier.price;
    }

    // 如果没找到（qty 超出最大阶梯），使用最大阶梯价格
    return tiers[tiers.length - 1].price;
  }
*/
  /* =========================
     slider 预览（拖动时）
     ========================= */
  function preview(percent) {
    const tiers = readTiers(optionRoot);
    if (!tiers.length) return;

    const min = 1;
    const max = tiers[tiers.length - 1].qty;
    const qty = Math.round(min + (max - min) * percent / 100);

    // slider 永远动
    prog.style.width = percent + '%';
    thumb.style.left = percent + '%';

    // 只显示数量预览，不写回 input
    bt.textContent = qty.toLocaleString() + ' pcs';

    // ⭐ 显示预览对应的单价
  const result = calculateUnitPrice(optionRoot, qty);
if (!result) return;
const unit = result.unit;
    if (Number.isFinite(unit)) {
      bb.textContent = '$' + unit.toFixed(3) + ' / each';
    }

    // 保存预览值，等 drag 结束再决定是否提交
    slider._previewQty = qty;
  }


  function onMove(e) {
    if (!dragging) return;
    const r = track.getBoundingClientRect();
    const x = e.touches ? e.touches[0].clientX : e.clientX;
    let p = (x - r.left) / r.width;
    p = Math.max(0, Math.min(1, p)) * 100;
    preview(p);
  }

  thumb.addEventListener('mousedown', e => {
    e.preventDefault();
    dragging = true;

    document.addEventListener('mousemove', onMove);
    document.addEventListener('mouseup', stopDrag);
  });

  thumb.addEventListener('touchstart', e => {
    dragging = true;

    document.addEventListener('touchmove', onMove, { passive: false });
    document.addEventListener('touchend', stopDrag);
  });

  /* =========================
     ⭐ 关键修复：input → slider 同步
     只同步 slider 显示位置，不写回 input
     ========================= */
  function syncSliderByQty(qty) {
    const tiers = readTiers(optionRoot);
    if (!tiers.length) return;

    const min = 1;
    const max = tiers[tiers.length - 1].qty;

    // ⭐ 核心修复：slider 显示位置限制在范围内，但 input 值保持不变
    const sliderQty = Math.max(min, Math.min(max, qty));
    const percent = ((sliderQty - min) / (max - min)) * 100;

    // ⭐ 根据实际 qty 计算单价（可能超出 slider 范围）
  const result = calculateUnitPrice(optionRoot, qty);
if (!result) return;
const unit = result.unit;

    prog.style.width = percent + '%';
    thumb.style.left = percent + '%';

    // ⭐ 关键：顶部气泡显示实际 input 值（可能超出 slider 范围）
    bt.textContent = qty.toLocaleString() + ' pcs';

    // ⭐ 底部气泡显示对应单价
    if (Number.isFinite(unit)) {
      bb.textContent = '$' + unit.toFixed(3) + ' / each';
    }
  }

  function syncSliderFromInput() {
    if (__ymqSliderWriting) return;
    const qty = parseInt(input.value, 10);
    if (!Number.isFinite(qty)) return;
    syncSliderByQty(qty);
  }

  // ⭐ 点击阶梯时，只更新 slider 显示，让 YMQ 自己去更新 input
  optionRoot.addEventListener('click', e => {
    const tier = e.target.closest('.ymq-option-qb-item');
    if (!tier) return;
    // 延迟等待 YMQ 更新 input
    setTimeout(() => {
      const qty = parseInt(input.value, 10);
      if (Number.isFinite(qty)) {
        syncSliderByQty(qty);
      }
    }, 50);
  });

  input.addEventListener('input', () => {
    if (__ymqSliderWriting) return;
    const qty = parseInt(input.value, 10);
    if (Number.isFinite(qty)) syncSliderByQty(qty);
  });

  input.addEventListener('change', () => {
    if (__ymqSliderWriting) return;
    const qty = parseInt(input.value, 10);
    if (Number.isFinite(qty)) syncSliderByQty(qty);
  });

  // 初始化
  const initialQty = parseInt(input.value, 10);
  if (Number.isFinite(initialQty)) {
    syncSliderByQty(initialQty);
  }

  preview(0);
  syncDeliveryBar();
}





  /* ================= Unlock 行增强 + 扫描（原样） ================= */
function initWholesaleUnlockRow(optionRoot) {
  if (optionRoot.querySelector('.ymq-unlock-wholesale')) return;

  const uploadAnchor = optionRoot.querySelector('.ymq-option-upload-wrapper');
  const deliveryBar  = optionRoot.querySelector('.ymq-delivery-bar');
  if (!uploadAnchor || !deliveryBar) return;

  /* 阶梯 qty 文案 */
  const tiers = $$('.ymq-option-qb-item', optionRoot)
    .filter(i => !i.classList.contains('ymq-option-qb-item-result'));

  let qtyText = '';
  if (tiers.length >= 4) {
    const qtyEl = $('.ymq-option-qb-quantity', tiers[3]);
    qtyText = qtyEl ? qtyEl.textContent.trim() : '';
  }

  /* wholesale radio */
  const wholesaleRadio = optionRoot.querySelector(
    '.laterclass input[type="radio"][value="wholesale"]'
  );

  /* ⭐ 滚动目标：product form 顶部 */
  const formTop =
    optionRoot.closest('form') ||
    document.querySelector('.product-form') ||
    document.querySelector('[id^="product-form"]');

  const row = document.createElement('div');
  row.className = 'ymq-unlock-row ymq-unlock-wholesale ymq-cta-block';
  row.innerHTML = `
    <div class="ymq-unlock-inner">
      <span class="ymq-unlock-text">
        ${qtyText ? `(Buy ${qtyText}) ` : ''}Unlock Your Wholesale Price
      </span>
    </div>
  `;

  row.addEventListener('click', e => {
    e.preventDefault();
    e.stopPropagation();

    const unlocked = document.documentElement.classList.toggle(
      'ymq-wholesale-unlocked'
    );

    /* 1️⃣ 同步 wholesale radio */
    if (wholesaleRadio) {
      wholesaleRadio.checked = unlocked;
      wholesaleRadio.dispatchEvent(
        new Event('change', { bubbles: true })
      );
    }

    /* 2️⃣ 解锁后滚动到 product-form 顶部 */
    if (unlocked && formTop) {
      formTop.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  });

  uploadAnchor.parentNode.insertBefore(row, uploadAnchor);
}


function scan() {
  $$('.product-stickersheet ymq-option').forEach(option => {

    /* ================== ① scan 只做一次 ================== */
    if (!option.dataset.ymqInited) {
      option.dataset.ymqInited = '1';

      // —— 只初始化一次的东西 ——
      initCustomQtyRow(option);

      const qtyBox = $('.ymq-option-quantity-container', option);
      if (qtyBox) initQtyCard(qtyBox, option);

      initSlider(option);
      initWholesaleUnlockRow(option);
      // ✅ 新增这一行（只负责阶梯内总价）
   
    }

    /* ================== ② scan 不再干任何“触发”事 ================== */
    // ❌ 不监听 click
    // ❌ 不触发 sync
    // ❌ 不读 active
  });
}


      scan();
      new MutationObserver(scan).observe(document.body, {
    childList: true,
    subtree: true
       });

})();



document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.ymq-option-quantity-input').forEach(input => {
    if (input.dataset.fakePlaceholderInit) return;
    input.dataset.fakePlaceholderInit = '1';

    const wrap = document.createElement('div');
    wrap.className = 'ymq-input-wrap';
    wrap.style.position = 'relative';

    input.parentNode.insertBefore(wrap, input);
    wrap.appendChild(input);

    const holder = document.createElement('span');
    holder.className = 'ymq-fake-placeholder';
    holder.textContent = 'Enter qty';
    wrap.appendChild(holder);

    function sync() {
      const v = input.value;
      if (v === '' || v === '1') {
        holder.style.display = 'block';
        input.classList.add('ymq-hide-value');
      } else {
        holder.style.display = 'none';
        input.classList.remove('ymq-hide-value');
      }
    }

    input.addEventListener('focus', () => {
      holder.style.display = 'none';
      input.classList.remove('ymq-hide-value');
    });

    input.addEventListener('blur', sync);
    input.addEventListener('input', sync);

    sync();
  });
});
  
(function () {
  // 所有 swatch 类型的 option 图片选项函数
  document
    .querySelectorAll('.ymq-options-box[ymq-option-type="5"]')
    .forEach(optionBox => {

      optionBox
        .querySelectorAll('.ymq-option-value-item')
        .forEach(item => {

          const input = item.querySelector('input.ymq-option-swatches-input');
          const swatch = item.querySelector('.ymq-option-swatches-item');

          if (!input || !swatch) return;

          // 防止重复注入
          if (swatch.querySelector('.ymq-option-text')) return;

          const textEl = document.createElement('div');
          textEl.className = 'ymq-option-text';
          textEl.textContent = input.value?.trim() || '';

          swatch.appendChild(textEl);
        });
    });
})();

/* ======================================
   YMQ Tier Total — SAFE VERSION
   ====================================== */
(function () {

  function insertTierTotals(wrapper) {
    wrapper.querySelectorAll(
      '.ymq-option-qb-item:not(.ymq-option-qb-item-result)'
    ).forEach(item => {

      const priceSpan = item.querySelector(
        '.ymq-option-qb-price .ymq-price-span[data-ymq-money]'
      );
      if (!priceSpan) return;

      const unit = parseFloat(priceSpan.dataset.ymqMoney);
      if (!Number.isFinite(unit)) return;

      const qtyEl = item.querySelector('.ymq-option-qb-quantity');
      if (!qtyEl) return;

      const qty = parseInt(qtyEl.textContent, 10);
      if (!Number.isFinite(qty)) return;

      const total = (unit * qty).toFixed(2);

      // ===== 货币符号（只读 YMQ DOM）=====
      let symbol = '$';
      if (priceSpan.textContent) {
        const m = priceSpan.textContent.match(/^[^\d]+/);
        if (m) symbol = m[0].trim();
      }

      const priceInfo = item.querySelector('.ymq-option-qb-price-info');
      if (!priceInfo) return;

      let badge = priceInfo.querySelector('.ymq-tier-total');
      if (!badge) {
        badge = document.createElement('div');
        badge.className = 'ymq-tier-total';
        priceInfo.appendChild(badge);
      }
 //  <span class="ymq-each"> / each </span>
      badge.innerHTML = `
<span class="ymq-each"> / each </span>
        <span class="ymq-tier-sum"> ${symbol}${total}</span>
      `;
    });
  }

  function scanAll() {
    document.querySelectorAll('.ymq-option-qb-wrapper')
      .forEach(insertTierTotals);
  }

  scanAll();

  // 尺寸 / 材质切换 → 重新读静态阶梯
  document.addEventListener('change', e => {
    if (e.target?.classList.contains('ymq-option-rc-input')) {
      requestAnimationFrame(scanAll);
    }
  });

})();
 

(function () {

  const ANCHOR_CLASS = 'ymq-action-anchor';

  const root = document.querySelector('.product-stickersheet');
  if (!root) return;

  const inquiry   = root.querySelector('.submitinquiryclass');
  const cart      = root.querySelector('.custom-add-to-cart');
  const accordion = document.querySelector('.custom-accordion');

  if (!cart && !inquiry && !accordion) return;

  /* =================================================
     1️⃣ 锁定唯一锚点列
  ================================================= */
  let column = root.querySelector(`.${ANCHOR_CLASS}`);
  if (!column) {
    const anchorEl = inquiry || cart;
    column = anchorEl?.closest('.ymq-option-group-content');
    if (!column) return;
    column.classList.add(ANCHOR_CLASS);
  }

  /* =================================================
     2️⃣ actionRow：询价 + 加购
  ================================================= */
  let actionRow = column.querySelector('.ymq-action-row');
  if (!actionRow) {
    actionRow = document.createElement('div');
    actionRow.className = 'ymq-action-row';
    column.appendChild(actionRow);
  }

  if (inquiry && !actionRow.contains(inquiry)) {
    actionRow.appendChild(inquiry);
  }

  if (cart && !actionRow.contains(cart)) {
    actionRow.appendChild(cart);
  }

  /* =================================================
     3️⃣ accordionRow：手风琴
  ================================================= */
  let accordionRow = column.querySelector('.ymq-accordion-row');
  if (!accordionRow) {
    accordionRow = document.createElement('div');
    accordionRow.className = 'ymq-accordion-row';
    column.appendChild(accordionRow);
  }

  if (accordion && !accordionRow.contains(accordion)) {
    accordionRow.appendChild(accordion);
  }

})();



 /* 自定义熊图 */
document.addEventListener('DOMContentLoaded', function () {
  const allButtons = document.querySelectorAll('.ymq-option-button-content');

  allButtons.forEach((btn) => {
    const textSpan = btn.querySelector('.ymq-option-value');
    if (!textSpan) return;

    const value = textSpan.textContent.trim().toLowerCase();

    // 只处理 Shape 相关选项
    if (!['circle', 'square', 'custom', 'bear'].includes(value)) return;

    // 防止重复注入
    if (btn.classList.contains('has-shape-icon')) return;

    // ⭐ 打标签（核心）
    btn.classList.add('has-shape-icon');

    // 创建 SVG
    const svgNS = "http://www.w3.org/2000/svg";
    const svg = document.createElementNS(svgNS, "svg");
    svg.setAttribute("viewBox", "0 0 50 50");
    svg.setAttribute("width", "50");
    svg.setAttribute("height", "50");
    svg.classList.add('injected-svg');

    // 绘制图形
    if (value === 'circle') {
      const circle = document.createElementNS(svgNS, "circle");
      circle.setAttribute("cx", "25");
      circle.setAttribute("cy", "25");
      circle.setAttribute("r", "20");
      circle.setAttribute("fill", "#a8f0c6");
      svg.appendChild(circle);

    } else if (value === 'square') {
      const rect = document.createElementNS(svgNS, "rect");
      rect.setAttribute("x", "5");
      rect.setAttribute("y", "5");
      rect.setAttribute("width", "50");
      rect.setAttribute("height", "50");
      rect.setAttribute("fill", "#a8f0c6");
      svg.appendChild(rect);

    } else {
  // custom / star (50x50)
const star = document.createElementNS(svgNS, "polygon");

star.setAttribute(
  "points",
  "25,2 31,18 48,18 34,29 39,46 25,36 11,46 16,29 2,18 19,18"
);

star.setAttribute("fill", "#a8f0c6");

svg.appendChild(star);
    }

    // 插入到文字上方
    const textWrap = btn.querySelector('.ymq-option-button-text');
    if (textWrap) {
      btn.insertBefore(svg, textWrap);
    }
  });
});

(function () {

  const SELECTOR    = '.nav-unlock-wholesale';
  const UNLOCK_TEXT = 'Unlock Wholesale Price';
  const BACK_TEXT   = 'Back to Regular Pricing';
  const ROOT_CLASS  = 'ymq-wholesale-unlocked';

  const html = document.documentElement;

  function getWholesaleRadio() {
    return document.querySelector(
      'input[type="radio"][value="wholesale"]'
    );
  }

  function syncAllNavText() {
    document.querySelectorAll(SELECTOR).forEach(btn => {
      btn.textContent = html.classList.contains(ROOT_CLASS)
        ? BACK_TEXT
        : UNLOCK_TEXT;
    });
  }

  /* ----------------------------
     ⭐ 重新匹配 URL 对应产品
  ---------------------------- */
  function rematchProductToURL() {

    const match = window.location.pathname.match(/\/products\/([^\/]+)/);
    if (!match) return;

    const handle = match[1];

    function normalize(str) {
      return str
        .toLowerCase()
        .trim()
        .replace(/\s+/g, '-')
        .replace(/[^a-z0-9-]/g, '');
    }

    const target = normalize(handle);

    const productBox = document.querySelector('.productclass');
    if (!productBox) return;

    const select = productBox.querySelector('select.ymq-dropdown');
    if (!select || !select.options.length) return;

    for (const option of select.options) {
      if (!option.value) continue;

      if (normalize(option.textContent) === target) {

        select.value = option.value;

        select.dispatchEvent(
          new Event('change', { bubbles: true })
        );

        break;
      }
    }
  }

  /* ----------------------------
     ⭐ 事件委托
  ---------------------------- */
  document.addEventListener('click', function (e) {

    const btn = e.target.closest(SELECTOR);
    if (!btn) return;

    e.preventDefault();

    const wasUnlocked = html.classList.contains(ROOT_CLASS);

    const unlocked = html.classList.toggle(ROOT_CLASS);

    const radio = getWholesaleRadio();
    if (radio) {
      radio.checked = unlocked;
      radio.dispatchEvent(
        new Event('change', { bubbles: true })
      );
    }

    syncAllNavText();

    /* ----------------------------
       ⭐ 只在 批发 → 零售 时执行
    ---------------------------- */
    if (wasUnlocked && !unlocked) {

      // 等 YMQ 切回零售模式后再执行
      setTimeout(rematchProductToURL, 100);

    }

  });

  syncAllNavText();

})();










(function () {

  /* =================================================
     常量
  ================================================= */

  const ROOT_UNLOCKED = 'ymq-wholesale-unlocked';
  const QUOTE_TRIGGER_CLASS = 'submitinquiryclass';

  // ⭐ 新增：数量冻结标记
  let __quantityFrozen = false;
  let __frozenQuantityValue = null;
  
  // ⭐ 新增：存储当前汇总数据，供签名区使用
  let __currentSummaryData = [];

  /* =================================================
     工具
  ================================================= */

  function isWholesaleUnlocked() {
    return document.documentElement.classList.contains(ROOT_UNLOCKED);
  }

  /* =================================================
     ⭐ 新增：冻结/解冻数量输入框
  ================================================= */
  
  function freezeQuantity() {
    const customInput = document.querySelector(
      'input[type="number"][name*="quantity"], input[type="text"][name*="quantity"], input[name="ymq_product_quantity"], input[id*="quantity"], .ymq-quantity-input'
    );
    
    if (customInput) {
      __frozenQuantityValue = customInput.value;
      __quantityFrozen = true;
      
      Object.defineProperty(customInput, 'value', {
        get: function() {
          return __frozenQuantityValue;
        },
        set: function(newVal) {
          if (!__quantityFrozen) {
            __frozenQuantityValue = newVal;
          }
          return __frozenQuantityValue;
        },
        configurable: true
      });
    }
  }
  
  function unfreezeQuantity() {
    __quantityFrozen = false;
    const customInput = document.querySelector(
      'input[type="number"][name*="quantity"], input[type="text"][name*="quantity"], input[name="ymq_product_quantity"], input[id*="quantity"], .ymq-quantity-input'
    );
    
    if (customInput && __frozenQuantityValue !== null) {
      customInput.value = __frozenQuantityValue;
      delete customInput.value;
      customInput.value = __frozenQuantityValue;
    }
  }

  /* =================================================
     Modal（只创建一次）
  ================================================= */

  function ensureModal() {
    if (document.querySelector('.ymq-quote-modal')) return;

    const modal = document.createElement('div');
    modal.className = 'ymq-quote-modal';

    modal.innerHTML = `
      <div class="ymq-quote-mask"></div>
      <div class="ymq-quote-panel">
        <button class="ymq-quote-close" type="button">×</button>
        <h2 class="ymq-quote-title">Submit Inquiry & Get Your Design Proof</h2>
        
        <div class="ymq-quote-scrollable">
          <div class="ymq-quote-summary-wrapper">
            <div class="ymq-quote-summary-header">
              <h3 class="ymq-summary-title">Configuration Summary</h3>
              <div class="ymq-summary-table"></div>
            </div>
          </div>
          <div class="ymq-quote-body"></div>
        </div>
      </div>
    `;

    document.body.appendChild(modal);
    modal.querySelector('.ymq-quote-mask').onclick = closeModal;
    modal.querySelector('.ymq-quote-close').onclick = closeModal;
  }

  /* =================================================
     ⭐ 获取最终数量值（冻结期间直接返回冻结值）
  ================================================= */

  function getFinalQuantityValue() {
    if (__quantityFrozen && __frozenQuantityValue !== null) {
      return {
        value: __frozenQuantityValue,
        numValue: parseInt(__frozenQuantityValue),
        source: 'custom',
        frozen: true
      };
    }
    
    const customInput = document.querySelector(
      'input[type="number"][name*="quantity"], input[type="text"][name*="quantity"], input[name="ymq_product_quantity"], input[id*="quantity"], .ymq-quantity-input'
    );

    if (customInput) {
      const customValue = customInput.value.trim();
      const customNum = parseInt(customValue);
      if (customValue && customValue !== '' && !isNaN(customNum) && customNum > 1) {
        return {
          value: customValue,
          numValue: customNum,
          source: 'custom',
          element: customInput,
          box: customInput.closest('.ymq-options-box')
        };
      }
    }

    const tierSelect = document.querySelector('.ymq-options-box select');
    if (tierSelect && tierSelect.value) {
      const selectedText = tierSelect.selectedOptions[0]?.innerText.trim();
      const match = selectedText.match(/([0-9,]+)/);
      if (match) {
        const num = parseInt(match[1].replace(/,/g, ''));
        return {
          value: match[1].replace(/,/g, ''),
          numValue: num,
          displayValue: selectedText,
          source: 'tier',
          element: tierSelect,
          box: tierSelect.closest('.ymq-options-box')
        };
      }
    }

    const checkedTier = document.querySelector('.ymq-options-box input[type="radio"]:checked, .ymq-options-box input[type="checkbox"]:checked');
    if (checkedTier) {
      const val = checkedTier.getAttribute('data-value') || checkedTier.value;
      const text = checkedTier.nextElementSibling?.innerText?.trim() || val;
      const num = parseInt(val);
      if (val && !isNaN(num) && num > 1) {
        return {
          value: val,
          numValue: num,
          displayValue: text,
          source: 'tier',
          element: checkedTier,
          box: checkedTier.closest('.ymq-options-box')
        };
      }
    }

    return null;
  }

  /* =================================================
     ⭐ 读取并渲染汇总表（使用冻结值）
  ================================================= */

  function renderSummaryTable() {
    const summaryContainer = document.querySelector('.ymq-summary-table');
    if (!summaryContainer) return;

    const rows = [];

    const quantityData = getFinalQuantityValue();
    if (quantityData) {
      rows.push({
        title: 'Quantity',
        value: quantityData.displayValue || quantityData.value,
        rawValue: quantityData.value,
        numValue: quantityData.numValue,
        source: quantityData.source,
        element: quantityData.element,
        box: quantityData.box,
        isEditable: true,
        frozen: quantityData.frozen || false
      });
    }

    document.querySelectorAll('.ymq-options-box').forEach(box => {
      if (!isElementVisible(box)) return;

      const titleEl = box.querySelector('.ymq-option-title, .ymq-option-label');
      if (!titleEl) return;
      
      const title = titleEl.innerText.trim();
      if (!title || isQuantityTitle(title)) return;

      let value = '';
      let displayValue = '';
      let element = null;

      const select = box.querySelector('select');
      if (select && select.value) {
        element = select;
        value = select.value;
        displayValue = select.selectedOptions[0]?.innerText.trim();
      } else {
        const checked = box.querySelector('input[type="radio"]:checked, input[type="checkbox"]:checked');
        if (checked) {
          element = checked;
          value = checked.getAttribute('data-value') || checked.value;
          displayValue = checked.nextElementSibling?.innerText?.trim() || value;
        } else {
          const input = box.querySelector('input[type="text"], textarea');
          if (input && input.value.trim()) {
            element = input;
            value = input.value.trim();
            displayValue = value;
          }
        }
      }

      if (value && displayValue) {
        rows.push({
          title: title,
          value: displayValue,
          rawValue: value,
          element: element,
          box: box,
          isEditable: false
        });
      }
    });

    // ⭐ 保存当前汇总数据，供签名区使用
    __currentSummaryData = rows.map(r => ({...r}));

    if (rows.length === 0) {
      summaryContainer.innerHTML = '<p class="ymq-summary-empty">No configuration selected.</p>';
      return;
    }

    const tableHtml = rows.map((row, index) => `
      <div class="ymq-summary-row" data-index="${index}" data-editable="${row.isEditable}">
        <span class="ymq-summary-label">${escapeHtml(row.title)}:</span>
        <span class="ymq-summary-value" data-raw="${escapeHtml(row.rawValue)}">${escapeHtml(row.value)}</span>
        <button type="button" class="ymq-summary-edit-btn" data-index="${index}">Edit</button>
      </div>
    `).join('');

    summaryContainer.innerHTML = tableHtml;

    summaryContainer.querySelectorAll('.ymq-summary-edit-btn').forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        const index = parseInt(this.getAttribute('data-index'));
        const rowData = rows[index];
        const rowEl = summaryContainer.querySelector(`[data-index="${index}"]`);

        if (!rowData || !rowEl) return;

        if (rowData.isEditable && rowData.title === 'Quantity') {
          if (__quantityFrozen) {
            unfreezeQuantity();
          }
          enableInlineEdit(rowEl, rowData, summaryContainer, rows);
        } else {
          closeModal();
          setTimeout(() => {
            rowData.box.scrollIntoView({ behavior: 'smooth', block: 'center' });
            rowData.element?.focus();
            rowData.box.classList.add('ymq-highlight-pulse');
            setTimeout(() => rowData.box.classList.remove('ymq-highlight-pulse'), 2000);
          }, 300);
        }
      });
    });
  }

  /* =================================================
     ⭐ 启用原地编辑（传递 rows 数组以便更新）
  ================================================= */

  function enableInlineEdit(rowEl, rowData, summaryContainer, allRows) {
    const valueSpan = rowEl.querySelector('.ymq-summary-value');
    const currentValue = rowData.rawValue;
    
    valueSpan.innerHTML = `<input type="number" class="ymq-inline-edit-input" value="${currentValue}" min="1" style="width:80px;padding:2px 6px;border:1px solid #007bff;border-radius:3px;font-size:13px;">`;
    
    const input = valueSpan.querySelector('input');
    input.focus();
    input.select();

    const saveValue = () => {
      const newValue = input.value.trim();
      const newNum = parseInt(newValue);
      
      if (newValue && !isNaN(newNum) && newNum >= 1) {
        // 更新显示
        valueSpan.textContent = newValue;
        rowData.rawValue = newValue;
        rowData.value = newValue;
        rowData.numValue = newNum;
        
        // ⭐ 同步更新原始输入框
        if (rowData.element) {
          rowData.element.value = newValue;
          try {
            rowData.element.dispatchEvent(new Event('input', { bubbles: true }));
            rowData.element.dispatchEvent(new Event('change', { bubbles: true }));
          } catch(e) {}
        }
        
        // ⭐ 关键：同步更新汇总数据存储
        __currentSummaryData = allRows.map(r => ({...r}));
        
        // ⭐ 关键：立即重新生成签名区
        regenerateSignature();
      } else {
        valueSpan.textContent = rowData.value;
      }
    };

    input.addEventListener('blur', saveValue);
    input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        input.blur();
      } else if (e.key === 'Escape') {
        valueSpan.textContent = rowData.value;
      }
    });
  }

  /* =================================================
     ⭐ 关键：直接使用汇总数据重新生成签名区
  ================================================= */

  function regenerateSignature() {
    if (!contactForm) return;
    
    const bodyField = contactForm.querySelector('[name="contact[body]"], [name="contact[message]"]');
    if (!bodyField) return;

    const SIGNATURE_FLAG = 'System Configuration (Do Not Edit)';
    
    // ⭐ 直接使用 __currentSummaryData 生成签名
    const lines = __currentSummaryData.map(row => {
      return `${row.title}: ${row.value}`;
    });

    if (!lines.length) return;

    // 检查是否已有签名区
    const currentValue = bodyField.value;
    let newValue;
    
    if (currentValue.includes(SIGNATURE_FLAG)) {
      // 替换现有签名区
      const beforeSignature = currentValue.split('────────────')[0] || currentValue;
      newValue = beforeSignature.trim() + `\n\n\n────────────\n${SIGNATURE_FLAG}\n${lines.join('\n')}\n────────────`;
    } else {
      // 新建签名区
      newValue = `${currentValue || '\n\n\n\n'}────────────\n${SIGNATURE_FLAG}\n${lines.join('\n')}\n────────────`;
    }
    
    bodyField.value = newValue;
  }

  /* =================================================
     ⭐ 注入 YMQ 产品配置到 contact[body] - 使用汇总数据
  ================================================= */

  function injectYmqToContactBody() {
    if (!contactForm) return;

    const bodyField = contactForm.querySelector('[name="contact[body]"], [name="contact[message]"]');
    if (!bodyField) return;

    const SIGNATURE_FLAG = 'System Configuration (Do Not Edit)';
    if (bodyField.value.includes(SIGNATURE_FLAG)) return;

    // ⭐ 使用当前汇总数据生成签名
    regenerateSignature();
  }

  /* =================================================
     工具函数
  ================================================= */

  function isElementVisible(element) {
    if (!element) return false;
    if (element.offsetParent === null) return false;
    const style = getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
  }

  function isQuantityTitle(title) {
    return /quantity|qty|数量|select quantity/i.test(title.toLowerCase());
  }

  function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  /* =================================================
     接管 Shopify 原生 contact form
  ================================================= */

  let contactForm = null;

  function captureContactFormForever() {
    ensureModal();
    const body = document.querySelector('.ymq-quote-body');
    if (!body) return;

    let tries = 0;
    const timer = setInterval(() => {
      const form = document.querySelector('form[action^="/contact"][method="post"]');
      if (form) {
        contactForm = form;
        body.appendChild(form);
        clearInterval(timer);
      }
      if (++tries > 40) clearInterval(timer);
    }, 100);
  }

  /* =================================================
     打开 / 关闭 Modal
  ================================================= */

  function openModal() {
    if (!isWholesaleUnlocked()) return;

    const customInput = document.querySelector(
      'input[type="number"][name*="quantity"], input[type="text"][name*="quantity"], input[name="ymq_product_quantity"]'
    );

    if (customInput) {
      __frozenQuantityValue = customInput.value;
      freezeQuantity();
    }

    document.body.classList.add('quote-open');
    
    setTimeout(() => {
      renderSummaryTable();
      injectYmqToContactBody();
    }, 50);
  }

  function closeModal() {
    document.body.classList.remove('quote-open');
    
    setTimeout(() => {
      unfreezeQuantity();
    }, 100);
  }

  /* =================================================
     询价按钮显示 / 隐藏
  ================================================= */

  function hideInquiryButton() {
    document.querySelectorAll(`.${QUOTE_TRIGGER_CLASS}`).forEach(btn => btn.style.display = 'none');
  }

  function showInquiryButton() {
    document.querySelectorAll(`.${QUOTE_TRIGGER_CLASS}`).forEach(btn => btn.style.display = '');
  }

  /* =================================================
     批发态监听
  ================================================= */

  function observeWholesaleState() {
    const apply = () => {
      if (isWholesaleUnlocked()) {
        showInquiryButton();
      } else {
        hideInquiryButton();
        closeModal();
      }
    };
    apply();
    
    const observer = new MutationObserver(apply);
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  }

  /* =================================================
     点击代理
  ================================================= */

  document.addEventListener('click', e => {
    if (e.target.closest(`.${QUOTE_TRIGGER_CLASS}`)) {
      const customInput = document.querySelector(
        'input[type="number"][name*="quantity"], input[type="text"][name*="quantity"], input[name="ymq_product_quantity"]'
      );
      if (customInput) {
        __frozenQuantityValue = customInput.value;
        freezeQuantity();
      }
      
      setTimeout(() => {
        openModal();
      }, 10);
    }
  });

  /* =================================================
     启动顺序
  ================================================= */

  captureContactFormForever();
  observeWholesaleState();

})();






      // 追加英寸换毫米
 
/* ==========================================
   YMQ Size Option (wholekeysizeclass only)
   Inch → MM UI Display
   ========================================== */

(function () {
  const INCH_TO_MM = 25.4;

  function inchToMM(inch) {
    return (inch * INCH_TO_MM).toFixed(1);
  }

  function appendMMToWholeKeySize() {
    document
      .querySelectorAll(
        '.wholekeysizeclass .ymq-option-value'
      )
      .forEach(el => {
        // 防止重复写入
        if (el.dataset.mmAdded) return;

        const raw = el.textContent.trim();
        const inch = parseFloat(raw);
        if (isNaN(inch)) return;

        const mm = inchToMM(inch);

        el.innerHTML = `
          <span class="ymq-inch">${inch}</span>
          <span class="ymq-mm">" (${mm}mm)</span>
        `;

        el.dataset.mmAdded = '1';
      });
  }

  /* 首次执行 */
  appendMMToWholeKeySize();

  /* 监听 YMQ 重渲染 */
  const observer = new MutationObserver(() => {
    appendMMToWholeKeySize();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
  





(function() {
  document.querySelectorAll(
    '.ymq-wholesale-unlocked .product-stickersheet .keywholematerialclass .ymq-option-value-info,.ymq-wholesale-unlocked .product-stickersheet .finishclass .ymq-option-value-info,.ymq-wholesale-unlocked .product-stickersheet .styleclass .ymq-option-value-info,.ymq-wholesale-unlocked .product-stickersheet .colorclass .ymq-option-value-info'
  ).forEach(el => {
    let isDown = false;
    let startX;
    let scrollLeft;

    el.addEventListener('mousedown', (e) => {
      isDown = true;
      el.classList.add('active'); // 可用于拖动样式变化
      startX = e.pageX - el.offsetLeft;
      scrollLeft = el.scrollLeft;
    });

    el.addEventListener('mouseleave', () => {
      isDown = false;
      el.classList.remove('active');
    });

    el.addEventListener('mouseup', () => {
      isDown = false;
      el.classList.remove('active');
    });

    el.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - el.offsetLeft;
      const walk = (x - startX) * 1.5; // 1.5 滚动速度，可调
      el.scrollLeft = scrollLeft - walk;
    });
  });
})();

/*
联系卡片
(function () {
  const CONTACT_MOVED = 'custom-contact-moved';

  function moveContactBanner() {
    const sizeRoot = document.querySelector('.wholekeysizeclass');
    const contact  = document.querySelector('.custom-accordion__contact');

    if (!sizeRoot || !contact) return;
    if (contact.classList.contains(CONTACT_MOVED)) return;

    // 标记，防止反复移动
    contact.classList.add(CONTACT_MOVED);

    // 和购物车一样：直接 append 到 size 区块尾部
    sizeRoot.appendChild(contact);
  }

  // DOMReady
  document.addEventListener('DOMContentLoaded', moveContactBanner);

  // YMQ / Shopify 异步兜底
  setTimeout(moveContactBanner, 300);
  setTimeout(moveContactBanner, 800);
})();
*/
(function () {
  const ACCORDION_MOVED = 'custom-accordion-moved';

  function moveAccordionToUpload() {
    const uploadRoot = document.querySelector('.uploadclass');
    const accordion  = document.querySelector('.custom-accordion');

    if (!uploadRoot || !accordion) return;
    if (accordion.classList.contains(ACCORDION_MOVED)) return;

    // 标记，防止被反复 append
    accordion.classList.add(ACCORDION_MOVED);

    // 和购物车 / contact 一样：直接挂到目标根节点
    uploadRoot.appendChild(accordion);
  }

  // 初次加载
  document.addEventListener('DOMContentLoaded', moveAccordionToUpload);

  // YMQ / Shopify 异步重绘兜底
  setTimeout(moveAccordionToUpload, 300);
  setTimeout(moveAccordionToUpload, 800);
})();

(function () {

  const COLLAPSED_HEIGHT = 32;   // 收起高度
  const MIN_EXPANDED_HEIGHT = 120; // 展开最小高度

  function isTargetTextarea(el) {
    return (
      el &&
      el.tagName === 'TEXTAREA' &&
      el.classList.contains('ymq-input-text') &&
      el.closest('.keynoteclass')
    );
  }

  function expandTextarea(textarea) {
    textarea.classList.add('ymq-textarea-expanded');
    textarea.style.height = 'auto';
    textarea.style.height = Math.max(
      textarea.scrollHeight,
      MIN_EXPANDED_HEIGHT
    ) + 'px';
  }

  function collapseTextarea(textarea) {
    textarea.classList.remove('ymq-textarea-expanded');
    textarea.style.height = COLLAPSED_HEIGHT + 'px';
  }

  // 聚焦 → 展开
  document.addEventListener('focusin', function (e) {
    const textarea = e.target;
    if (!isTargetTextarea(textarea)) return;
    expandTextarea(textarea);
  });

  // 输入 → 自动撑高
  document.addEventListener('input', function (e) {
    const textarea = e.target;
    if (!isTargetTextarea(textarea)) return;

    textarea.style.height = 'auto';
    textarea.style.height = Math.max(
      textarea.scrollHeight,
      MIN_EXPANDED_HEIGHT
    ) + 'px';
  });

  // 失焦 → 没内容才收起
  document.addEventListener('focusout', function (e) {
    const textarea = e.target;
    if (!isTargetTextarea(textarea)) return;

    if (!textarea.value.trim()) {
      collapseTextarea(textarea);
    }
  });

})();








(function() {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function() {
    var stickerSheet = document.querySelector('.product-stickersheet');
    if (!stickerSheet) return;

    var charms = [
      { num: 1, widthClass: 'charm1width', heightClass: 'charm1height', label: 'Charm 1:' },
      { num: 2, widthClass: 'charm2width', heightClass: 'charm2height', label: 'Charm 2:' },
      { num: 3, widthClass: 'charm3width', heightClass: 'charm3height', label: 'Charm 3:' },
      { num: 4, widthClass: 'charm4width', heightClass: 'charm4height', label: 'Charm 4:' }
    ];

    var baseConfig = { widthClass: 'basewidth', heightClass: 'baselength', label: 'Base Size:' };

    function createDimensionRow(config, isBase) {
      var widthEl = stickerSheet.querySelector('.' + config.widthClass);
      var heightEl = stickerSheet.querySelector('.' + config.heightClass);
      if (!widthEl || !heightEl) return null;

      var widthInput = widthEl.querySelector('input') || widthEl;
      var heightInput = heightEl.querySelector('input') || heightEl;

      var row = document.createElement('div');
      row.className = 'dimension-row' + (isBase ? ' base-row' : '');
      row.innerHTML = '<span class="dimension-row-label">' + config.label + '</span>' +
        '<div class="dimension-input-wrap"><input type="number" placeholder="W" style="width:80px;height:40px;text-align:center;border:1px solid #ced4da;border-radius:8px;"></div>' +
        '<span class="dimension-multiply">×</span>' +
        '<div class="dimension-input-wrap"><input type="number" placeholder="H" style="width:80px;height:40px;text-align:center;border:1px solid #ced4da;border-radius:8px;"></div>' +
        '<span style="font-size:13px;color:#868e96;margin-right:16px;">mm</span>';

      var wInput = row.querySelectorAll('input')[0];
      var hInput = row.querySelectorAll('input')[1];

      // 同步值
      wInput.value = widthInput.value;
      hInput.value = heightInput.value;

      wInput.addEventListener('input', function() { widthInput.value = this.value; });
      hInput.addEventListener('input', function() { heightInput.value = this.value; });

      widthEl.style.display = 'none';
      heightEl.style.display = 'none';

      return row;
    }

    var wrapper = document.createElement('div');
    wrapper.className = 'dimensions-wrapper';
    wrapper.innerHTML = '<div style="font-size:15px;font-weight:700;color:#212529;margin-right:16px;padding-bottom:10px;border-bottom:1px solid #e9ecef;">Enter Dimensions</div>';

    var charmRows = [];
    charms.forEach(function(charm) {
      var row = createDimensionRow(charm, false);
      if (row) {
        charmRows.push(row);
        wrapper.appendChild(row);
      }
    });

    var baseRow = createDimensionRow(baseConfig, true);
    if (baseRow) wrapper.appendChild(baseRow);

    // 插入到页面
    var firstCharm = stickerSheet.querySelector('.charm1width');
    if (firstCharm) {
      firstCharm.parentNode.insertBefore(wrapper, firstCharm);
    } else {
      stickerSheet.appendChild(wrapper);
    }

    // 监听数量变化
    function updateVisibleCharms() {
      var selectedCount = 4;
      var radios = stickerSheet.querySelectorAll('input[type="radio"]');
      radios.forEach(function(radio) {
        if (radio.checked && radio.name && radio.name.indexOf('Numbers') !== -1) {
          var val = parseInt(radio.value);
          if (!isNaN(val) && val >= 1 && val <= 4) selectedCount = val;
        }
      });

      charmRows.forEach(function(row, index) {
        if (index + 1 <= selectedCount) {
          row.classList.remove('hidden');
          row.style.display = 'flex';
        } else {
          row.classList.add('hidden');
          row.style.display = 'none';
        }
      });
    }

    stickerSheet.addEventListener('change', function(e) {
      if (e.target.type === 'radio') setTimeout(updateVisibleCharms, 50);
    });

    updateVisibleCharms();
  });
})();



(function () {
  const params = new URLSearchParams(window.location.search);
  if (params.get('wholesale') !== '1') return;

  function scrollToDashboard() {
    const dashboard = document.querySelector('.product-stickersheet'); // ← 改成你的仪表盘选择器
    if (!dashboard) return false;

    const headerOffset = 0; // sticky header 高度
    const y =
      dashboard.getBoundingClientRect().top +
      window.pageYOffset -
      headerOffset;

    window.scrollTo({
      top: y,
      behavior: 'smooth'
    });

    return true;
  }

  // 如果元素还没渲染，轮询等它
  let tries = 0;
  const timer = setInterval(() => {
    if (scrollToDashboard() || tries > 20) {
      clearInterval(timer);
    }
    tries++;
  }, 100);
})();



document.addEventListener('DOMContentLoaded', function () {

  const handle = window.location.pathname.split('/products/')[1];
  if (!handle) return;

  function normalize(str) {
    return str
      .toLowerCase()
      .trim()
      .replace(/\s+/g, '-')
      .replace(/[^a-z0-9-]/g, '');
  }

  const target = normalize(handle);

  const interval = setInterval(() => {

    // 只锁定 productclass 这一组
    const productBox = document.querySelector('.productclass');
    if (!productBox) return;

    const select = productBox.querySelector('select.ymq-dropdown');
    if (!select || !select.options.length) return;

    let matched = false;

    Array.from(select.options).forEach(option => {

      if (!option.value) return; // 跳过 placeholder

      const optionText = normalize(option.textContent);

      if (optionText === target) {
        select.value = option.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        matched = true;
      }

    });

    if (matched) clearInterval(interval);

  }, 200);

});(function () {
  'use strict';

  // 配置数据 - 支持多选择器
  const TOOLTIPS = {
    resin: {
      // 使用数组定义多个选择器，匹配不同位置但相同功能的元素
      selectors: [
        '.product-stickersheet .keywholematerialclass .ymq-option-title',
        '.product-stickersheet .stickermaterialclass  .ymq-option-title',  // 其他产品类型
        '.product-stickersheet .pin2wholeshapeclass .ymq-option-title'    // 另一个位置
      ],
      title: "What's this?",
      content: `
        <div class="ymq-tooltip-content">
          <p class="main-desc"><strong>Epoxy Resin</strong> is the clear protective top layer that covers your design.</p>
          
          <ul class="features">
            <li><span class="icon">💧</span> Waterproof & scratch-resistant</li>
            <li><span class="icon">☀️</span> Safe for daily outdoor use</li>
            <li><span class="icon">🌱</span> Eco-friendly material</li>
            <li><span class="icon">⏳</span> Long-lasting clarity</li>
          </ul>
          
          <div class="divider"></div>
          
          <p class="tldr"><strong>TL;DR:</strong> Controls thickness, durability & shine.</p>
          
          <div class="options-section">
            <strong>How to choose:</strong>
            <div class="option-item"><b>Single-Sided:</b> Front coating only — lighter feel</div>
            <div class="option-item"><b>Double-Sided:</b> Both sides coated — thicker & stronger</div>
            <div class="option-item"><b>Glittered:</b> Sparkle effect embedded in resin ✨</div>
          </div>
        </div>
      `
    },
    holo: {
      selectors: [
        '.product-stickersheet .finishclass .ymq-option-title',
        '.product-stickersheet .stickerfinishclass .ymq-option-title',
        '.product-stickersheet .pinsfinishclass .ymq-option-title'
      ],
      title: "What's this?",
      content: `
        <div class="ymq-tooltip-content">
          <p class="main-desc"><strong>Holographic Film</strong> is the sparkle effect layer that changes how your keychain shines under light.</p>
          
          <ul class="features">
            <li><span class="icon">🌈</span> Shifts colors at different angles</li>
            <li><span class="icon">✨</span> Your artwork stays visible underneath</li>
            <li><span class="icon">🎨</span> Adds premium, eye-catching finish</li>
          </ul>
          
          <div class="effects-grid">
            <strong>Available effects:</strong>
            <div class="effects-list">
              <span class="effect-tag">⭐ Holo Star</span>
              <span class="effect-tag">💔 Broken Glass</span>
              <span class="effect-tag">❤️ Heart Holo</span>
              <span class="effect-tag">🌈 Rainbow</span>
            </div>
          </div>
          
          <div class="divider"></div>
          
          <p class="tldr"><strong>TL;DR:</strong> Controls how it sparkles and the overall vibe.</p>
          
          <div class="sides-note">
            <b>Single vs Double:</b> One side or both sides with holographic effect
          </div>
        </div>
      `
    }
  };

  // 创建全局样式
  function injectStyles() {
    if (document.getElementById('ymq-tooltip-styles')) return;
    
    const style = document.createElement('style');
    style.id = 'ymq-tooltip-styles';
    style.textContent = `
      /* 触发器样式 */
      .ymq-tooltip-trigger {
        display: inline-flex;
        align-items: center;
        margin-left: 8px;
        padding: 2px 8px;
        background: rgba(0,0,0,0.05);
        border-radius: 12px;
        color: #666;
        font-size: 11px;
        font-weight: 500;
        cursor: pointer;
        transition: all 0.2s ease;
        user-select: none;
        border: 1px solid transparent;
      }
      
      .ymq-tooltip-trigger:hover {
        background: rgba(0,0,0,0.08);
        color: #333;
        border-color: rgba(0,0,0,0.1);
      }
      
      .ymq-tooltip-trigger.active {
        background: #333;
        color: #fff;
      }
      
      /* 固定定位的提示框容器 - 挂载到 body 避免裁切 */
      .ymq-tooltip-portal {
        position: fixed;
        z-index: 2147483647; /* 最大 z-index */
        pointer-events: none;
        opacity: 0;
        visibility: hidden;
        transition: opacity 0.2s ease, visibility 0.2s ease, transform 0.2s ease;
        transform: translateY(-8px) scale(0.96);
      }
      
      .ymq-tooltip-portal.visible {
        opacity: 1;
        visibility: visible;
        pointer-events: auto;
        transform: translateY(0) scale(1);
      }
      
      /* 提示框内容样式 */
      .ymq-tooltip-box {
        background: rgba(25, 25, 25, 0.98);
        color: #fff;
        padding: 16px 18px;
        border-radius: 12px;
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
        font-size: 13px;
        line-height: 1.5;
        max-width: 320px;
        min-width: 280px;
        box-shadow: 0 20px 40px rgba(0,0,0,0.3), 0 0 0 1px rgba(255,255,255,0.1);
        position: relative;
        /* 关键：防止文字溢出 */
        word-wrap: break-word;
        overflow-wrap: break-word;
        hyphens: auto;
      }
      
      /* 小箭头 */
      .ymq-tooltip-box::before {
        content: '';
        position: absolute;
        top: -6px;
        left: 24px;
        width: 12px;
        height: 12px;
        background: rgba(25, 25, 25, 0.98);
        transform: rotate(45deg);
        border-radius: 2px;
        z-index: -1;
      }
      
      .ymq-tooltip-box.arrow-bottom::before {
        top: auto;
        bottom: -6px;
      }
      
      /* 内容样式 */
      .ymq-tooltip-content .main-desc {
        margin: 0 0 12px 0;
        font-size: 13px;
        line-height: 1.5;
        color: #fff;
      }
      
      .ymq-tooltip-content .main-desc strong {
        color: #ffd700;
        font-weight: 600;
      }
      
      .ymq-tooltip-content .features {
        margin: 0 0 14px 0;
        padding: 0;
        list-style: none;
      }
      
      .ymq-tooltip-content .features li {
        margin-bottom: 6px;
        font-size: 12px;
        color: #e0e0e0;
        display: flex;
        align-items: flex-start;
        gap: 6px;
        line-height: 1.4;
      }
      
      .ymq-tooltip-content .features .icon {
        flex-shrink: 0;
        font-size: 14px;
        line-height: 1;
      }
      
      .ymq-tooltip-content .divider {
        height: 1px;
        background: rgba(255,255,255,0.15);
        margin: 12px 0;
      }
      
      .ymq-tooltip-content .tldr {
        margin: 0 0 12px 0;
        font-size: 12px;
        color: #ccc;
        font-style: italic;
        line-height: 1.4;
      }
      
      .ymq-tooltip-content .tldr strong {
        color: #fff;
        font-style: normal;
      }
      
      .ymq-tooltip-content .options-section,
      .ymq-tooltip-content .effects-grid {
        background: rgba(255,255,255,0.08);
        padding: 12px;
        border-radius: 8px;
        margin-top: 10px;
      }
      
      .ymq-tooltip-content .options-section strong,
      .ymq-tooltip-content .effects-grid strong {
        display: block;
        margin-bottom: 8px;
        font-size: 12px;
        color: #fff;
        font-weight: 600;
      }
      
      .ymq-tooltip-content .option-item {
        font-size: 11px;
        color: #ddd;
        margin-bottom: 6px;
        line-height: 1.4;
        padding-left: 8px;
        border-left: 2px solid rgba(255,215,0,0.3);
      }
      
      .ymq-tooltip-content .option-item:last-child {
        margin-bottom: 0;
      }
      
      .ymq-tooltip-content .option-item b {
        color: #ffd700;
        font-weight: 600;
      }
      
      .ymq-tooltip-content .effects-list {
        display: flex;
        flex-wrap: wrap;
        gap: 6px;
      }
      
      .ymq-tooltip-content .effect-tag {
        background: rgba(255,255,255,0.1);
        padding: 4px 8px;
        border-radius: 6px;
        font-size: 11px;
        color: #eee;
        white-space: nowrap;
      }
      
      .ymq-tooltip-content .sides-note {
        margin-top: 10px;
        font-size: 11px;
        color: #aaa;
        line-height: 1.4;
      }
      
      .ymq-tooltip-content .sides-note b {
        color: #ccc;
      }
      
      /* 移动端适配 */
      @media (max-width: 768px) {
        .ymq-tooltip-portal {
          position: fixed;
          left: 50% !important;
          top: 50% !important;
          transform: translate(-50%, -50%) scale(0.96) !important;
        }
        
        .ymq-tooltip-portal.visible {
          transform: translate(-50%, -50%) scale(1) !important;
        }
        
        .ymq-tooltip-box {
          max-width: 90vw;
          min-width: 280px;
          max-height: 80vh;
          overflow-y: auto;
        }
        
        .ymq-tooltip-box::before {
          display: none;
        }
        
        /* 添加遮罩层 */
        .ymq-tooltip-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0,0,0,0.5);
          z-index: 2147483646;
          opacity: 0;
          visibility: hidden;
          transition: opacity 0.2s ease;
        }
        
        .ymq-tooltip-overlay.visible {
          opacity: 1;
          visibility: visible;
        }
      }
    `;
    document.head.appendChild(style);
  }

  // 创建工具提示元素
  function createTooltip(data, triggerId) {
    const portal = document.createElement('div');
    portal.className = 'ymq-tooltip-portal';
    portal.id = `ymq-tooltip-${triggerId}`;
    portal.setAttribute('role', 'tooltip');
    
    const box = document.createElement('div');
    box.className = 'ymq-tooltip-box';
    box.innerHTML = data.content;
    
    portal.appendChild(box);
    document.body.appendChild(portal);
    
    return portal;
  }

  // 计算位置
  function positionTooltip(portal, trigger) {
    const triggerRect = trigger.getBoundingClientRect();
    const portalRect = portal.getBoundingClientRect();
    const box = portal.querySelector('.ymq-tooltip-box');
    
    // 默认显示在触发器下方
    let top = triggerRect.bottom + 8;
    let left = triggerRect.left;
    
    // 检查是否超出视口右侧
    if (left + portalRect.width > window.innerWidth - 16) {
      left = window.innerWidth - portalRect.width - 16;
    }
    
    // 检查是否超出视口底部，如果是则显示在上方
    if (top + portalRect.height > window.innerHeight - 16) {
      top = triggerRect.top - portalRect.height - 8;
      box.classList.add('arrow-bottom');
    } else {
      box.classList.remove('arrow-bottom');
    }
    
    // 确保不超出左侧
    left = Math.max(16, left);
    
    portal.style.top = `${top}px`;
    portal.style.left = `${left}px`;
  }

  // 隐藏单个 tooltip
  function hideTooltip(tooltip, trigger, activeTooltips) {
    tooltip.classList.remove('visible');
    if (trigger) trigger.classList.remove('active');
    if (trigger && trigger.dataset.tooltipId) {
      activeTooltips.delete(trigger.dataset.tooltipId);
    }
    
    // 移除遮罩
    const overlay = document.getElementById('ymq-tooltip-overlay');
    if (overlay) overlay.classList.remove('visible');
  }

  // 隐藏所有 tooltip
  function hideAllTooltips(activeTooltips) {
    activeTooltips.forEach((tooltip, id) => {
      const trigger = document.querySelector(`[data-tooltip-id="${id}"]`);
      hideTooltip(tooltip, trigger, activeTooltips);
    });
  }

  // 显示遮罩层
  function showOverlay() {
    let overlay = document.getElementById('ymq-tooltip-overlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.id = 'ymq-tooltip-overlay';
      overlay.className = 'ymq-tooltip-overlay';
      document.body.appendChild(overlay);
    }
    overlay.classList.add('visible');
    return overlay;
  }

  // 绑定事件
  function bindEvents(trigger, tooltip, data, activeTooltips) {
    const show = () => {
      // 先隐藏其他所有 tooltip
      activeTooltips.forEach((tip, id) => {
        if (id !== trigger.dataset.tooltipId) {
          const otherTrigger = document.querySelector(`[data-tooltip-id="${id}"]`);
          hideTooltip(tip, otherTrigger, activeTooltips);
        }
      });
      
      positionTooltip(tooltip, trigger);
      tooltip.classList.add('visible');
      trigger.classList.add('active');
      activeTooltips.set(trigger.dataset.tooltipId, tooltip);
      
      // 移动端添加遮罩
      if (window.innerWidth <= 768) {
        const overlay = showOverlay();
        // 点击遮罩关闭
        overlay.onclick = () => hideAllTooltips(activeTooltips);
      }
    };
    
    const hide = () => {
      hideTooltip(tooltip, trigger, activeTooltips);
    };
    
    // 鼠标悬停显示
    trigger.addEventListener('mouseenter', show);
    trigger.addEventListener('mouseleave', (e) => {
      // 检查是否移动到了 tooltip 上
      setTimeout(() => {
        if (!tooltip.matches(':hover') && !trigger.matches(':hover')) {
          hide();
        }
      }, 50);
    });
    
    // tooltip 鼠标离开
    tooltip.addEventListener('mouseenter', () => {
      // 保持显示
    });
    tooltip.addEventListener('mouseleave', () => {
      if (!trigger.matches(':hover')) {
        hide();
      }
    });
    
    // 点击切换（移动端）
    trigger.addEventListener('click', (e) => {
      e.stopPropagation();
      if (tooltip.classList.contains('visible')) {
        hide();
      } else {
        show();
      }
    });
  }

  // 初始化
  function init() {
    injectStyles();
    
    let tooltipIdCounter = 0;
    const activeTooltips = new Map(); // 存储当前显示的 tooltip
    
    // 处理每个配置
    Object.values(TOOLTIPS).forEach(data => {
      // 遍历所有选择器
      data.selectors.forEach(selector => {
        const elements = document.querySelectorAll(selector);
        
        elements.forEach(el => {
          // 防止重复初始化
          if (el.dataset.ymqTooltipInitialized) return;
          el.dataset.ymqTooltipInitialized = 'true';
          
          // 创建触发器
          const trigger = document.createElement('span');
          trigger.className = 'ymq-tooltip-trigger';
          trigger.textContent = data.title;
          trigger.dataset.tooltipId = tooltipIdCounter++;
          
          el.appendChild(trigger);
          
          // 创建对应的 tooltip（挂载到 body）
          const tooltip = createTooltip(data, trigger.dataset.tooltipId);
          
          // 绑定事件
          bindEvents(trigger, tooltip, data, activeTooltips);
        });
      });
    });
    
    // 窗口滚动和调整大小时重新定位
    window.addEventListener('scroll', () => {
      activeTooltips.forEach((tooltip, id) => {
        if (tooltip.classList.contains('visible')) {
          const trigger = document.querySelector(`[data-tooltip-id="${id}"]`);
          if (trigger) positionTooltip(tooltip, trigger);
        }
      });
    }, { passive: true });
    
    window.addEventListener('resize', () => {
      activeTooltips.forEach((tooltip, id) => {
        if (tooltip.classList.contains('visible')) {
          const trigger = document.querySelector(`[data-tooltip-id="${id}"]`);
          if (trigger) positionTooltip(tooltip, trigger);
        }
      });
    });
    
    // 点击外部关闭
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.ymq-tooltip-portal') && !e.target.closest('.ymq-tooltip-trigger')) {
        hideAllTooltips(activeTooltips);
      }
    });
  }

  // 等待 DOM 就绪
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  // 监听动态内容变化
  const observer = new MutationObserver((mutations) => {
    let shouldInit = false;
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1 && (
          node.matches?.('[class*="product-"]') || 
          node.querySelector?.('[class*="product-"]')
        )) {
          shouldInit = true;
        }
      });
    });
    
    if (shouldInit) {
      setTimeout(init, 100);
    }
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();


(function() {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function() {
    var sheet = document.querySelector('.product-stickersheet');
    if (!sheet || sheet.dataset.dimFixed) return;
    sheet.dataset.dimFixed = 'true';

    var longEl = sheet.querySelector('.longclass');
    var shortEl = sheet.querySelector('.shortclass');
    if (!longEl || !shortEl) return;

    // 找到输入框
    var longInput = longEl.querySelector('input') || longEl;
    var shortInput = shortEl.querySelector('input') || shortEl;
// 关键检查：如果找不到输入框，隐藏原始元素并退出
    if (!longInput || !shortInput) {
      if (longEl) longEl.style.display = 'none';
      if (shortEl) shortEl.style.display = 'none';
      return;
    }
    // 创建极简包装器
    var wrap = document.createElement('div');
    wrap.className = 'dim-wrap';
    wrap.style.cssText = 'display:flex;align-items:center;gap:8px;margin-top: -56px;';

    // 创建乘号
    var mult = document.createElement('span');
    mult.textContent = '×';
    mult.style.cssText = 'color:#666;font-size:14px;font-weight:500;';

    // 创建单位
    var unit = document.createElement('span');
    unit.textContent = 'mm';
    unit.style.cssText = 'color:#868e96;font-size:12px;margin-left:4px;';

    // 组装：long + × + short + mm
    var parent = longEl.parentNode;
    var next = longEl.nextSibling;

    wrap.appendChild(longEl);
  
    wrap.appendChild(shortEl);
   

    parent.insertBefore(wrap, next);

    // 极简样式输入框
    [longInput, shortInput].forEach(function(inp) {
      inp.style.cssText = 'width:70px;height:32px;padding:4px 8px;font-size:13px;text-align:center;border:1px solid #ddd;border-radius:6px;background:#fff;margin:0;';
    });

    // 隐藏原始标签
    [longEl, shortEl].forEach(function(el) {
      var lbl = el.querySelector('label, .ymq-option-title, .option-name');
      if (lbl) lbl.style.display = 'none';
    });
  });
})();